import React, { useState, useEffect } from "react";
import PanelHeader from "components/PanelHeader/PanelHeader";
import {
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  CardTitle,
  Button,
  FormGroup,
  Input
} from "reactstrap";
import useGlobal from "store";

const ProfilePage = (props) => {

  const [response, actions] = useGlobal(
    state => state.response,
    actions => actions
  );

  const [user] = useGlobal(
    state => state.user
  );

  const [confirmPassword, setConfirmPassword] = useState('');

  const [formState, setFormState] = useState({
      email: '',
      first_name: '',
      last_name: '',
      password: ''
  });

  useEffect(() => {
    if(!user) {
      return;
    }
    setFormState({
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name
    });
  }, [user]);

  const handleInputChange = (event) => {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;
      let formFields = { ...formState };
      formFields[name] = value;
      setFormState(formFields);
  }

  const saveProfile = () => {
      console.log('save profile', formState);
      if(formState.password && formState.password !== confirmPassword) {
          actions.notifierActions.notify('Passwords do not match!', 'danger', 'tc');
          return;
      }
      actions.userActions.updateUser(formState);
  }

  useEffect(() => {
      if(!response || response.type !== "userupdated") {
          return;
      }
      actions.notifierActions.notify('Profile saved!', 'success', 'br');
  }, [response, actions.notifierActions]);


    return (
        <>
        <PanelHeader size="sm" />
        <div className="content">
         
          <Row>
            <Col md="6">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">My Profile</CardTitle>
                </CardHeader>
                <CardBody>
                    <FormGroup>
                        <label>Email</label>
                        <Input type="text" placeholder="Email" name="email" onChange={handleInputChange} value={formState.email || ''} />
                    </FormGroup>
                    <FormGroup>
                        <label>First Name</label>
                        <Input type="text" placeholder="First Name" name="first_name" onChange={handleInputChange} value={formState.first_name || ''} />
                    </FormGroup>
                    <FormGroup>
                        <label>Last Name</label>
                        <Input type="text" placeholder="Last Name" name="last_name" onChange={handleInputChange} value={formState.last_name || ''} />
                    </FormGroup>
                    <FormGroup>
                        <label>New Password</label>
                        <Input type="password" placeholder="New Password" name="password" onChange={handleInputChange} value={formState.password || ''} />
                    </FormGroup>
                    <FormGroup>
                        <label>Confirm Password</label>
                        <Input type="password" placeholder="Confirm Password" name="confirm_password" onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword} />
                    </FormGroup>
                    <Button
                          block
                          color="primary"
                          size="lg"
                          type="button"
                          className="mb-3 mt-3 btn-round"
                          onClick={() => saveProfile()}
                        >
                          OK
                        </Button>
                </CardBody>
            </Card>
            </Col>
            </Row>
        </div>
        </>
    );

}
export default ProfilePage;